import React from 'react';
import { FormGroup, Label } from 'reactstrap';

export const teachoutRequiredError = teachoutFlag =>
    teachoutFlag === null || teachoutFlag === undefined
        ? 'Please indicate whether a teach-out is required.'
        : null;

export const TeachoutField = ({ id, value, onChange, submitted = false }) => (
    <FormGroup>
        <Label>
            Does it require teaching out students? <sup className="text-danger">*</sup>
        </Label>
        <div>
            <div className="form-check form-check-inline">
                <input
                    className="form-check-input"
                    type="radio"
                    id={`${id}-yes`}
                    name={id}
                    checked={value === true}
                    onChange={() => onChange(true)}
                />
                <label className="form-check-label" htmlFor={`${id}-yes`}>
                    Yes
                </label>
            </div>
            <div className="form-check form-check-inline">
                <input
                    className="form-check-input"
                    type="radio"
                    id={`${id}-no`}
                    name={id}
                    checked={value === false}
                    onChange={() => onChange(false)}
                />
                <label className="form-check-label" htmlFor={`${id}-no`}>
                    No
                </label>
            </div>
        </div>
        {submitted && teachoutRequiredError(value) && (
            <p className="text-danger mt-1">{teachoutRequiredError(value)}</p>
        )}
    </FormGroup>
);

export const allStudentsTaughtOutError = allStudentsTaughtOut =>
    allStudentsTaughtOut === null || allStudentsTaughtOut === undefined
        ? 'Please indicate whether all students are taught out.'
        : null;

export const AllStudentsTaughtOutField = ({ id, value, onChange, submitted = false }) => (
    <FormGroup>
        <Label>
            Are all of the students taught out? <sup className="text-danger">*</sup>
        </Label>
        <div>
            <div className="form-check form-check-inline">
                <input
                    className="form-check-input"
                    type="radio"
                    id={`${id}-yes`}
                    name={id}
                    checked={value === true}
                    onChange={() => onChange(true)}
                />
                <label className="form-check-label" htmlFor={`${id}-yes`}>
                    Yes
                </label>
            </div>
            <div className="form-check form-check-inline">
                <input
                    className="form-check-input"
                    type="radio"
                    id={`${id}-no`}
                    name={id}
                    checked={value === false}
                    onChange={() => onChange(false)}
                />
                <label className="form-check-label" htmlFor={`${id}-no`}>
                    No
                </label>
            </div>
        </div>
        {submitted && allStudentsTaughtOutError(value) && (
            <p className="text-danger mt-1">{allStudentsTaughtOutError(value)}</p>
        )}
    </FormGroup>
);
